// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Control } from '../../elements/Control';
import HeatmapSymbolInfoTemplate from '@front/templates/HeatmapSymbolInfoTemplate.html';
import { Resources } from '@shared/localizations/Resources';
import { HeatmapLogoProvider } from './HeatmapLogoProvider';
import { DataCache } from '@shared/commons/DataCache';
export class HeatmapSymbolInfo extends Control {
    constructor() {
        super();
    }
    getType() {
        return 'HeatmapSymbolInfo';
    }
    oninit() {
        super.oninit();
        this.onUpdateInstrument = this.onUpdateInstrument.bind(this);
        DataCache.OnUpdateInstrument.Subscribe(this.onUpdateInstrument, this);
        HeatmapLogoProvider.subscribeOnLoad(this.onUpdateInstrument);
    }
    onteardown() {
        DataCache.OnUpdateInstrument.UnSubscribe(this.onUpdateInstrument, this);
        HeatmapLogoProvider.unsubscribeOnLoad(this.onUpdateInstrument);
        super.onteardown();
    }
    localize() {
        void this.set('lastPriceLabel', Resources.getResource('property.Last'));
        void this.set('changeLabel', Resources.getResource('property.Change'));
        void this.set('changePercentLabel', Resources.getResource('property.ChangePercent'));
        void this.set('marketCapLabel', Resources.getResource('property.MarketCap'));
    }
    onUpdateInstrument(instrument) {
        const heatmapData = super.get('heatmapData');
        if (!isNullOrUndefined(heatmapData) && heatmapData.Instrument === instrument) {
            void this.update();
        }
    }
}
Control.extendWith(HeatmapSymbolInfo, {
    template: HeatmapSymbolInfoTemplate,
    data: function () {
        return {
            heatmapData: null,
            symbol: '',
            symbolLabel: '',
            lastPrice: '',
            lastPriceLabel: '',
            change: '',
            changeLabel: '',
            changePercent: '',
            changePercentLabel: '',
            marketCap: '',
            marketCapLabel: ''
        };
    },
    computed: {
        logoImage: function () {
            const heatmapData = this.get('heatmapData');
            if (!isNullOrUndefined(heatmapData) && isValidString(heatmapData.logoAddress)) {
                const logoImage = HeatmapLogoProvider.getLogo(heatmapData.logoAddress);
                return !isNullOrUndefined(logoImage) ? logoImage.src : null;
            }
            else {
                return null;
            }
        }
    }
});
